import {showWarning} from './utils.ts';

export class FirstLoginPage
{
    private readonly formContainer = document.getElementById('loginPage') as HTMLElement;
    private readonly ageForm = document.getElementById('ageForm') as HTMLFormElement;
    private readonly loginForm = document.getElementById('loginForm') as HTMLFormElement;
    private readonly loginUsernameInput = document.getElementById('loginUsername') as HTMLInputElement;
    private readonly loginPasswordInput = document.getElementById('loginPassword') as HTMLInputElement;
    private readonly loginBtn = document.getElementById('loginBtn') as HTMLButtonElement;
    private readonly onCreateAccount: (birthdate: string, age: number) => void;
    private readonly onLogin: (username: string, password: string) => Promise<void>;

    constructor(
        onCreateAccount: (birthdate: string, age: number) => void,
        onLogin: (username: string, password: string) => Promise<void>
    ) {
        this.onCreateAccount = onCreateAccount;
        this.onLogin = onLogin;
    }

    public setupHandlers() {
        let that = this
        this.ageForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const birth = (document.getElementById('birthdate') as HTMLInputElement).value;
            const age = Number((document.getElementById('age') as HTMLInputElement).value);
            that.onCreateAccount(birth, age)
        });

        this.loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (this.loginBtn.disabled) {
                return;
            }
            
            const username = this.loginUsernameInput.value.trim();
            const password = this.loginPasswordInput.value;
            
            if (!username) {
                showWarning('Please enter a login');
                this.loginUsernameInput.focus();
                return;
            }
            if (!password) {
                showWarning('Please enter a password');
                this.loginPasswordInput.focus();
                return;
            }
            
            this.loginBtn.disabled = true;
            const originalText = this.loginBtn.textContent;
            this.loginBtn.textContent = 'Logging in...';
            
            try {
                await that.onLogin(username, password);
            } finally {
                this.loginBtn.disabled = false;
                this.loginBtn.textContent = originalText || 'Login';
                // Clear password for security, but keep username for convenience
                this.loginPasswordInput.value = '';
            }
        });
    }

    public show() {
        this.formContainer.style.display = 'flex';
        // Clear password field for security when showing the form
        this.loginPasswordInput.value = '';
    }

    public hide() {
        this.formContainer.style.display = 'none';
    }
}